import { PrivaLocalizationService } from '@priva/localization';

import { Tile, tileGroupName } from '../../../components/tile-list/models';
import {
    loginRegistrationDefinition,
    logoutRegistrationDefinition,
    startBreakRegistrationDefinition,
    TimeRegistrationDefinition,
} from '../models';

/**
 * Maps a TimeRegistrationDefinition to a Tile object.
 * @param name name to display on tile, e.g. "Work Day" or "End break"
 * @param definition time registration definition to map from
 * @param iconClass icon to display next to tile title
 * @param groupName group tiles according to this name, e.g. "Work Day" or "End Break"
 */
export const mapTimeRegistrationDefinitionToTile = (
    name: string,
    definition: TimeRegistrationDefinition,
    iconClass: string,
    groupName: string,
): Tile => ({
    groupName,
    iconClass: iconClass ?? '',
    iconText: definition.activity?.number.toString() ?? '',
    id: definition.id,
    isSeparator: false,
    name,
    tags: definition.activity?.number.toString(),
});

/**
 * The below functions create Tile objects for the 3 system activities (start break, login, logout) using the mapping function above.
 * The name of the tile is retrieved from the localization service,
 * remaining properties are based on the time registration definition of each activity.
 */

export const createStartBreakTile = (privaLocalizationService: PrivaLocalizationService) =>
    mapTimeRegistrationDefinitionToTile(
        privaLocalizationService.instant(startBreakRegistrationDefinition.name),
        startBreakRegistrationDefinition,
        'fa-solid fa-pause',
        tileGroupName.WorkDay,
    );

export const createLoginTile = (privaLocalizationService: PrivaLocalizationService) =>
    mapTimeRegistrationDefinitionToTile(
        privaLocalizationService.instant(loginRegistrationDefinition.name),
        loginRegistrationDefinition,
        'fa-solid fa-play',
        tileGroupName.WorkDay,
    );

export const createLogoutTile = (privaLocalizationService: PrivaLocalizationService) =>
    mapTimeRegistrationDefinitionToTile(
        privaLocalizationService.instant(logoutRegistrationDefinition.name),
        logoutRegistrationDefinition,
        'fa-solid fa-stop',
        tileGroupName.WorkDay,
    );
